import { render, staticRenderFns } from "./nrnf-notice.vue?vue&type=template&id=6b2c45c6&scoped=true&"
import script from "./nrnf-notice.vue?vue&type=script&lang=js&"
export * from "./nrnf-notice.vue?vue&type=script&lang=js&"
import style0 from "./nrnf-notice.vue?vue&type=style&index=0&id=6b2c45c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2c45c6",
  null
  
)

export default component.exports